window.onload = function () {
    Echo.private(`drive.dashboard`)
        .listen('DriveStarted', (e) => {
            console.log("Relaying Echo event to Livewire: DriveStarted");
            Livewire.emit('DriveStarted', e.drive);
        })
        .listen('DriveUpdated', (e) => {
            console.log("Relaying Echo event to Livewire: DriveUpdated");
            Livewire.emit('DriveUpdated', e.drive);
        })
        .listen('DriveEnded', (e) => {
            console.log("Relaying Echo event to Livewire: DriveEnded");
            Livewire.emit('DriveEnded', e.drive);
        })
        .listen('DriveWaypointsAdded', (e) => {
            console.log("Relaying Echo event to Livewire: DriveWaypointsAdded");
            Livewire.emit('DriveWaypointsAdded', e.drive);
        })
        ;
}
